import React from "react";
import { useTranslation } from "react-i18next";

import { ArrangedUseLimitsData } from "../../../models/featureUseLimits/FeatureUseLimitsData";
import { FeatureTypes } from "../../../models/featureUseLimits/FeatureUseLimitsData.const";
import Pagination from "../../Pagination";
import { IndividualSettingItem } from "../IndividualSettingItem";
import { IndividualSettingListHeader } from "../IndividualSettingListHeader/Index";
import ListTopBar from "../ListTopBar";
import "./styles.scss";

export interface IFunctionIndividualSettingListProps {
  arrangedUseLimits: ArrangedUseLimitsData[];
  filterFormData: any;
  totalCount: number;
  targetType: FeatureTypes;
  onChangeFilterFormData: (filterFormData: any) => void;
  onClickEdit: (useLimit: ArrangedUseLimitsData) => void;
  onClickFilter: () => void;
  onClickClearFilterCondition: () => void;
}

const FunctionIndividualSettingList: React.FunctionComponent<
  IFunctionIndividualSettingListProps
> = ({
  arrangedUseLimits,
  filterFormData,
  totalCount,
  targetType,
  onClickEdit,
  onClickFilter,
  onChangeFilterFormData,
  onClickClearFilterCondition,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`functionManagementPage.individualSettingList.${key}`);

  const hasActiveFilter =
    !!filterFormData.searchKeyword ||
    (filterFormData.useLimitsStatus || []).some(
      (item: any) => item.can_use !== undefined
    );

  return (
    <div className="white-border-panel individual-setting-list">
      <ListTopBar
        filterFormData={filterFormData}
        targetType={targetType}
        onChangeFilterFormData={(filterFormData: any) => {
          onChangeFilterFormData(filterFormData);
        }}
        onClickFilter={onClickFilter}
        onClickClearFilterCondition={onClickClearFilterCondition}
      />
      <div className="table-data table-data-grid table-data-grid-pc-only">
        <IndividualSettingListHeader
          targetType={targetType}
          filterFormData={filterFormData}
          onChangeFilterFormData={onChangeFilterFormData}
          onClickFilter={onClickFilter}
        />
        {arrangedUseLimits.length === 0 && (
          <div className="row-td sub-txt no-data-message">
            <div className="no-data-message-inner">
              {hasActiveFilter
                ? t("no_filtered_results")
                : t("no_data_message")}
            </div>
          </div>
        )}
        {arrangedUseLimits.map((item) => (
          <IndividualSettingItem
            key={item.target_id}
            arrangedUseLimits={item}
            onClickEdit={() => onClickEdit(item)}
          />
        ))}
      </div>

      <Pagination
        filterFormData={filterFormData}
        totalRowsNumber={totalCount}
        onChangeFilterFormData={(filterFormData: any) => {
          onChangeFilterFormData(filterFormData);
        }}
      />
    </div>
  );
};

export default FunctionIndividualSettingList;
